// src/components/LocationChips.js

import React from 'react';
import Chip from '@mui/material/Chip';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const LocationChips = ({ locations, handleDelete }) => {
    return (
        <Box mt={1}>
            {locations.map((location, index) => (
                <Chip
                    key={index}
                    icon={<LocationOnIcon />}
                    label={`Location ${index + 1}`}
                    onDelete={() => handleDelete(index)}
                    sx={{ margin: 0.5 }}
                />
            ))}
        </Box>
    );
};

LocationChips.propTypes = {
    locations: PropTypes.arrayOf(
        PropTypes.shape({
            latitude: PropTypes.number.isRequired,
            longitude: PropTypes.number.isRequired,
        })
    ).isRequired,
    handleDelete: PropTypes.func.isRequired,
};

export default LocationChips;
